import { createSlice, PayloadAction } from "@reduxjs/toolkit";
// Define a type for the slice state

// Define the initial state using that type

const claimListSlice = createSlice({
  name: "claimList",

  initialState: { claimList: [], claimListLoader: false },
  reducers: {
    setAllClaimList: (state: any, action: PayloadAction<any>) => {
      const payload = action.payload;
      state.claimList = payload;
    },
    setAllClaimListLoader: (state: any, action: PayloadAction<any>) => {
      const payload = action.payload;
      state.claimListLoader = payload;
    },
    resetAllClaimList: (state) => {
      state.claimList = [];
    },
  },
});

export const { setAllClaimList, resetAllClaimList, setAllClaimListLoader } =
  claimListSlice.actions;

// // Other code such as selectors can use the imported `RootState` type
// export const selectCount = (state: RootState) => state.counter.value

export default claimListSlice.reducer;
